import { Logo } from "./Logo";

// Lightweight sticky top nav: Foton wordmark + module label. White BG with
// subtle border-bottom to keep the visual lift, no shadow.
export function Nav() {
  return (
    <nav
      className="sticky top-0 z-40 bg-white/90 backdrop-blur-sm border-b border-ink-100"
      aria-label="Foton nav"
    >
      <div className="mx-auto max-w-[1280px] px-6 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <LogoDark height={22} />
          <span className="hidden sm:inline-block w-px h-5 bg-ink-200" />
          <span className="hidden sm:inline font-mono text-[11px] uppercase tracking-wider text-ink-500">
            moduł · analiza postępu remontów
          </span>
        </div>
        <a
          href="https://foton.works"
          target="_blank"
          rel="noopener noreferrer"
          className="font-mono text-[11px] uppercase tracking-wider text-ink-500 hover:text-foton transition-colors"
        >
          foton.works →
        </a>
      </div>
    </nav>
  );
}

// The brand SVG ships with light-grey wordmark (#EDEDED), tuned for dark
// backgrounds. On a white nav we invert via CSS filter to render it dark.
function LogoDark({ height }: { height: number }) {
  return (
    <span
      className="inline-block"
      style={{ filter: "invert(1) brightness(0.6)" }}
      aria-hidden
    >
      <Logo height={height} />
    </span>
  );
}
